export { default } from './ArrowRight'
